import { Injectable } from '@angular/core';
import { Observable, Subject, takeUntil, withLatestFrom } from 'rxjs';
import { Store } from '@ngrx/store';
import { CaptchaActions } from '@app/core/actions';
import * as fromRoot from '@app/reducers/index';

@Injectable({
    providedIn: 'root'
})
export class ResolveCaptchaService {
    action: string;
    token: string;

    constructor(
        private readonly store$: Store<fromRoot.State>,
    ) { }

    verifyToken({ token }: { token: string }): void {
        this.token = token;
        this.store$.dispatch(CaptchaActions.VerifyCaptcha({ token, action: this.action }));
    }

    resolve({ action }: { action: string }): Observable<{ captchaResponse: string, captchaError: string }> {
        this.action = action;
        this.store$.dispatch(CaptchaActions.ResetVerifyCaptcha());
        this.store$.dispatch(CaptchaActions.StartVerifyCaptcha()); // used for signup modal
        const resolvedCaptcha$ = new Subject<{ captchaResponse: string, captchaError: string }>();
        this.store$.pipe(
            withLatestFrom(
                this.store$.select(fromRoot.getVerifyCaptchaResponse),
                this.store$.select(fromRoot.getVerifyCaptchaError),
            ),
            takeUntil(resolvedCaptcha$)
        ).subscribe(([store,
            captchaResponse, captchaError,
        ]) => {
            if (captchaResponse || captchaError) {
                resolvedCaptcha$.next({ captchaResponse, captchaError });
            }
        });

        return resolvedCaptcha$.asObservable();
    }

}